import * as Sentry from "@sentry/react";

// Define an interface for error logging options
interface ErrorLoggerOptions {
  page?: string;
  component?: string;
  action?: string;
  extra?: Record<string, any>;
  tags?: Record<string, string>;
  hook?: string;
  url?: string;
}

/**
 * Centralized error logging utility for Sentry
 * @param error - The error to log
 * @param options - Optional configuration for error logging
 */
export const logError = (
  error: any, 
  options: ErrorLoggerOptions = {}
) => {
  // Skip logging in development if needed
  if (import.meta.env.DEV) {
    console.error('Error logged:', error);
  }

  Sentry.withScope((scope) => {
    // Set default tag
    scope.setTag('error_type', 'application_error');

    if (options.page) {
      scope.setTag('page', options.page);
    }

    // Add component tag if provided
    if (options.component) {
      scope.setTag('component', options.component);
    }

    // Add action tag if provided
    if (options.action) {
      scope.setTag('action', options.action);
    }

    if (options.hook) {
      scope.setTag('hook', options.hook);
    }

    // Add additional tags
    if (options.tags) {
      Object.entries(options.tags).forEach(([key, value]) => {
        scope.setTag(key, value);
      });
    }

    // Add extra context
    if (options.extra) {
      Object.entries(options.extra).forEach(([key, value]) => {
        scope.setExtra(key, value);
      });
    }

    // Capture the exception
    Sentry.captureException(error);
  });
};